<template>
    <div>
        <strong>When will this message be sent</strong>

        <div v-if="template_context === 'auto-message-reservation-ecellar-booked'">
            <ul>
                <li>RedChirp will send this message whenever a new reservation is created in eCELLAR that is in the <strong>booked</strong> state</li>
                <li>RedChirp will send this message whenever an existing reservation is modified to be in the <strong>booked</strong> state (i.e was not in that state before but is now)</li>
                <li>The message will be sent once per <strong>reservation</strong> -- it will never be sent more than once per reservation</li>
                <li><strong>Please note</strong> that this automated message does not preclude sending reservation created and reservation updated messages.  Generally, it is not advisable to use this message in combination with those other messages.</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-ecellar-requested'">
            <ul>
                <li>RedChirp will send this message whenever a new reservation is created in eCELLAR that is in the <strong>requested</strong> state</li>
                <li>RedChirp will send this message whenever an existing reservation is modified to be in the <strong>requested</strong> state (i.e was not in that state before but is now)</li>
                <li>The message will be sent once per <strong>reservation</strong> -- it will never be sent more than once per reservation</li>
                <li><strong>Please note</strong> that this automated message does not preclude sending reservation created and reservation updated messages.  Generally, it is not advisable to use this message in combination with those other messages.</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-ecellar-visited'">
            <ul>
                <li>RedChirp will send this message whenever a new reservation is created in eCELLAR that is in the <strong>visited</strong> state</li>
                <li>RedChirp will send this message whenever an existing reservation is modified to be in the <strong>visited</strong> state (i.e was not in that state before but is now)</li>
                <li>The message will be sent once per <strong>reservation</strong> -- it will never be sent more than once per reservation</li>
                <li><strong>Please note</strong> that this automated message does not preclude sending reservation created and reservation updated messages.  Generally, it is not advisable to use this message in combination with those other messages.</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-ecellar-tentative'">
            <ul>
                <li>RedChirp will send this message whenever a new reservation is created in eCELLAR that is in the <strong>tentative</strong> state</li>
                <li>RedChirp will send this message whenever an existing reservation is modified to be in the <strong>tentative</strong> state (i.e was not in that state before but is now)</li>
                <li>The message will be sent once per <strong>reservation</strong> -- it will never be sent more than once per reservation</li>
                <li><strong>Please note</strong> that this automated message does not preclude sending reservation created and reservation updated messages.  Generally, it is not advisable to use this message in combination with those other messages.</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-almost-time'">
            <ul>
                <li>RedChirp will send this message as early as two hours before the reservation time and as late as thirty minutes before the reservation time</li>
                <li>RedChirp will try and send this message as early as possible:  Under most circumstances, this message will be sent two hours before the reservation time</li>
                <li>The message will only be sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li v-if="is_ecellar_enabled"><strong>eCELLAR Specific:</strong>  RedChirp will only send this message if the reservation is in the <strong>booked</strong> state</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-morning-of'">
            <ul>
                <li>Every day, between 8:00 AM and 10:00 AM, RedChirp will send messages for that day's reservations</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 8:00 AM and 8:15 AM on the day of a reservation</li>
                <li>This message will not be sent for reservations with a scheduled time before 8:00 AM</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li v-if="is_ecellar_enabled"><strong>eCELLAR Specific:</strong>  RedChirp will only send this message if the reservation is in the <strong>booked</strong> state</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-day-before'">
            <ul>
                <li>Every day, between 11:00 AM and 4:00 PM, RedChirp will send messages for tomorrow's reservations</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 11:00 AM and 11:30 AM the day before a reservation</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li v-if="is_ecellar_enabled"><strong>eCELLAR Specific:</strong>  RedChirp will only send this message if the reservation is in the <strong>booked</strong> state</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-two-days-before'">
            <ul>
                <li>Every day, between 11:00 AM and 4:00 PM, RedChirp will send messages for reservations that are two days from now</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 11:00 AM and 11:30 AM the two days before a reservation</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li v-if="is_ecellar_enabled"><strong>eCELLAR Specific:</strong>  RedChirp will only send this message if the reservation is in the <strong>booked</strong> state</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-at-start-time'">
            <ul>
                <li>RedChirp will try and send this message as soon as possible after a reservation start time.</li>
                <li>Under most circumstances, this message will go out within 10 minutes of a reservation's scheduled start time</li>
                <li>The message will <strong>not</strong> be sent for cancelled or tentative reservations</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li>You can use this message to create a follow up at any desired time following a reservation by setting the "Delay before sending" field to your desired follow up time</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-day-after'">
            <ul>
                <li>Every day, between 11:00 AM and 4:00 PM, RedChirp will send messages for non-cancelled reservations the day after the reservation time (i.e. yesterday's reservations)</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 11:00 AM and 11:30 AM the day after a reservation</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-week-before'">
            <ul>
                <li>Every day, between 2:30 PM and 4:00 PM, RedChirp will send messages for reservations scheduled for 7 days hence</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 2:30 PM and 2:45 PM, 7 days before a reservation's date</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
            </ul>
        </div>

        <div v-if="template_context === 'auto-message-reservation-reminder-month-before'">
            <ul>
                <li>Every day, between 2:30 PM and 4:00 PM, RedChirp will send messages for reservations scheduled for 30 days hence</li>
                <li>RedChirp will try and send this message as soon as possible:  Under most circumstances, this message will go out between 2:30 PM and 2:45 PM, 30 days before a reservation's date</li>
                <li>The message will only sent once per reservation (even if the reservation is rescheduled etc.)</li>
                <li v-if="is_ecellar_enabled"><strong>eCELLAR Specific:</strong>  RedChirp will only send this message if the reservation is in the <strong>booked</strong> state</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReservationMessageInfo',

    props: {
        template_context: {
            type: String,
            required: true
        },
        is_ecellar_enabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
